
























import Vue from 'vue';
import { format, parseISO } from "date-fns";

type stepInterface = {
    completed: boolean,
    color: string,
    name: string,
    date?: Date
}

export default Vue.extend({

    // props:{
    //     steps: [] as stepInterface[]
    // }
    props: ["steps", "showLoader"],

	data(){
		return{
			style: {
				backgroundColor: '#7a009c',
				borderColor: '#7a009c'
			}
		}
	},

	methods: {
		formatDate(date: string){
			return format(parseISO(date), "dd.M.yyyy");
		},

		isNullUndefinedEmpty(val: any){
			if(val === "" || val === undefined || val === null){
				return true;
			}

			return false;
		},

		generateStepStyle(index: number){
			const step = this.steps[index];
			return{
				backgroundColor: step.backgroundColor,
				borderColor: step.borderColor
			}
		}
	}

})
